import React, { useEffect } from 'react'
import { MDBRadio } from 'mdb-react-ui-kit'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ResetPasswordUrl, applicationContextRoot, handleSessionUrl, resetUserPassword } from '../../../constants/constants';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { getLoginInfoUrl } from '../../../constants/constants';
import { setUserInfo } from '../../system/redux/reducers/roleReducer';
import { setMenuInfo } from '../../system/redux/reducers/menuReducer';
import { Button, Form } from 'react-bootstrap';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { t } from 'i18next';

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required("general.field.password.old.validation.notEmpty")
    .min(8, "general.field.password.validation.limit.min"),
  password: Yup.string()
    .required("general.field.password.validation.notEmpty")
    .min(7, "general.field.password.validation.limit.min") // Minimum length
    .max(15, "general.field.password.validation.limit.max") // Maximum length
    .matches(/[a-z]/, "general.field.password.validation.charachter.lower") // Lowercase letter
    .matches(/[A-Z]/, "general.field.password.validation.charachter.upper") // Uppercase letter
    .matches(/\d/, "general.field.password.validation.charachter.digit") // Digit
    .matches(
      /[@#$%^+=]/,
      "general.field.password.validation.charachter.special"
    ) // Special character
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^+=])[A-Za-z\d@#$%^+=]{8,15}$/,
      "general.field.password.validation.invalidPassword"
    ),

  confirmPassword: Yup.string()
    .required("general.field.confirmPassword.validation.notEmpty")
    .oneOf([Yup.ref("password")], 'general.field.confirmPassword.validation.identicalToPassword'),
});


const ResetPassword = ({ onErrorFromLogin }) => {
    const [isCheckedOne, setIsCheckedOne] = useState(false);
    const [isCheckedTwo, setIsCheckedTwo] = useState(true);
    const [menu, setMenu] = useState([]);
    const navigate = useNavigate();
    const [previous, setPrevious] = useState(false);
    const dispatch = useDispatch();
    const { csrfToken } = useSelector((state) => state.csrf);
    const [error, setError] = useState('');
    const headers = {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrfToken,
    };
  
    const onTrigger = (msg) => {
        onErrorFromLogin(msg);
        console.log('input');
    };
    const { register, handleSubmit, formState: { errors } } = useForm();

    const [formData, setFormData] = useState({
      _csrf: csrfToken,
      oldPassword: "",
      password: "",
      confirmPassword: "",
      submitButton:true
    });
    const [errorMessage, setErrorMessage] = useState([]);

    const onChangeHandler = (event)=>{
        debugger;
        const {name,value} = event.target;

        setErrorMessage((prev) => {
          const newArr = prev.filter((errorObj) => errorObj.path !== name);
          debugger;
          return newArr;
        });
        setFormData((prev)=>{
            return {...prev,[name]:value}
        });
    }
    const onSubmit = (data) => {
        validationSchema
          .validate(data)
          .then((jsonPayload) => {
            debugger;
            const payload = new FormData();
            payload.append("_csrf", jsonPayload._csrf);
            payload.append("oldPassword", jsonPayload.oldPassword);
            payload.append("password", jsonPayload.password);
            payload.append("confirmPassword", jsonPayload.confirmPassword);
            payload.append("submitButton", "true");

            // Send the payload to the server using axios or fetch
            axios
              .post(
                ResetPasswordUrl,
                payload,
                { withCredentials: true },
                headers
              )
              .then((response) => {
                const redirectUrl = response.data;
                console.log(response);
                if (response.data.includes("resetPassword")) {
                  setError(
                    t("general.field.password.validation.invalidOldPassword")
                  );
                  onTrigger(t('general.field.password.validation.invalidOldPassword'));
                } else if (redirectUrl) {
                  const decodedUrl = decodeURIComponent(redirectUrl);
                  const successMessage = new URLSearchParams(
                    decodedUrl.split("?")[1]
                  ).get("success");
                  if (successMessage) {
                    onTrigger(successMessage);
                    console.log("msg" + successMessage);
                    setError(successMessage);
                  } else {
                    onTrigger(
                      t('page.reset.password.error.internal')
                    );
                  }
                } else {
                  onTrigger(t("page.reset.password.error.internal"));
                }
              })
              .catch((error) => {
                console.error("Error resetting password:", error);
                onTrigger(t('page.reset.password.error.internal'));
              });
          })
          .catch((exception) => {
            setErrorMessage((prev) => {
              const newError = {
                path: exception.path,
                message: exception.message,
              };
              return [...prev, { ...newError }];
            });
          });
        
    };

    return (
      <>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="fw-medium">
              {t("general.field.password.old.label")}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              placeholder={t("general.field.password.old.placeHolder")}
              {...register("oldPassword")}
              name={"oldPassword"}
              isInvalid={
                errorMessage.filter((obj) => obj.path === "oldPassword")
                  .length > 0
              }
              onChange={onChangeHandler}
            />
            {errorMessage !== null &&
              errorMessage !== undefined &&
              errorMessage.filter((obj) => obj.path === "oldPassword").length >
                0 && (
                <Form.Control.Feedback type="invalid">
                  {
                    t(errorMessage.filter((obj) => obj.path === "oldPassword")[0]
                      .message)
                  }
                </Form.Control.Feedback>
              )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="fw-medium">
              {t("general.field.password.new.label")}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              placeholder={t("general.field.password.new.placeHolder")}
              {...register("password")}
              name={"password"}
              isInvalid={
                errorMessage.filter((obj) => obj.path === "password").length > 0
              }
              onChange={onChangeHandler}
            />
            {errorMessage !== null &&
              errorMessage !== undefined &&
              errorMessage.filter((obj) => obj.path === "password").length >
                0 && (
                <Form.Control.Feedback type="invalid">
                  {
                    t(errorMessage.filter((obj) => obj.path === "password")[0]
                      .message)
                  }
                </Form.Control.Feedback>
              )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="fw-medium">
              {t("general.field.confirmPassword.label")}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              placeholder={t("general.field.confirmPassword.placeHolder")}
              {...register("confirmPassword")}
              name={"confirmPassword"}
              isInvalid={
                errorMessage.filter((obj) => obj.path === "confirmPassword")
                  .length > 0
              }
              onChange={onChangeHandler}
            />
            {errorMessage !== null &&
              errorMessage !== undefined &&
              errorMessage.filter((obj) => obj.path === "confirmPassword")
                .length > 0 && (
                <Form.Control.Feedback type="invalid">
                  {
                    t(errorMessage.filter(
                      (obj) => obj.path === "confirmPassword"
                    )[0].message)
                  }
                </Form.Control.Feedback>
              )}
          </Form.Group>
          <Button
            onClick={() => onSubmit(formData)}
            className="w-100"
            size="lg"
          >
            {t("general.button.submit.label")}
          </Button>
        </Form>

        <p className="text-center mt-3 mb-0 text-danger">
          {t("page.reset.password.buttom.msg")}
        </p>
      </>
    );
}
export default ResetPassword;